import React from 'react';
import "./../../ReportView/ReportDetailContainer/ReportDetailContainer.scss"
import DetailViewOverlay from "../../DetailView/DetailViewOverlay"
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Fabric } from 'office-ui-fabric-react/lib/';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { FontSizes, Stack, Text } from 'office-ui-fabric-react/lib';
import { Depths } from '@uifabric/fluent-theme/lib/fluent/FluentDepths';
import RIAccordion from "../../ConversationSafe/Accordion/RIAccordion";

import zipcelx from 'zipcelx';
import { MyContext } from '../../../context';

const config = {
    filename: 'report',
    sheet: {
        data: [
            [{
                value: "date",
                type: 'string'
            }, {
                value: 'time',
                type: 'string'
            }, {
                value: "userId",
                type: 'string'
            }, {
                value: "userLogin",
                type: 'string'
            }, {
                value: "active",
                type: 'string'
            }, {
                value: "content",
                type: 'string'
            }, {
                value: "size (MB)",
                type: 'string'
            }
            ]
        ]
    }
};

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px'
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden'
            }
        }
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '20px',
        maxWidth: '20px'
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px'
    },
    selectionDetails: {
        marginBottom: '20px'
    }
});

export interface IDocument {
    conversationType: Boolean,
    conversationID: String,
    conversationDirection: String,
    initiator: String,
    date: String,
    starttime: String,
    endtime: String,
    duration: String,
    attendees: String,
    notes: String,
    transcription: String

}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}



export default class ReportUserContainer extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: IDocument[];
    constructor(props: {}) {
        super(props);

        this.detailContainerRef = React.createRef();

        this._allItems = this.props.isGrouped ? [] : this._generateDocuments(props.data.entry);

        this._allGroupedItems = this.props.isGrouped ? this.props.data.groupedEntries.map(folder => ({
            ...folder, reportEntries: this._generateDocuments(folder.reportEntries)
        })) : []


        let columns = [
            {
                key: 'column1',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "date")}</>)}</MyContext.Consumer>,
                fieldName: 'dateValue',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'date',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.date}</span>;
                }
            },
            {
                key: 'column2',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "time")}</>)}</MyContext.Consumer>,
                fieldName: 'dateValue',
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                data: 'date',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.starttime}</span>;
                }
            },
            {
                key: 'column3',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "userId")}</>)}</MyContext.Consumer>,
                fieldName: 'participants',
                minWidth: 150,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.userId}</span>;
                },
                isPadded: true
            },
            {
                key: 'column4',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "userLogin")}</>)}</MyContext.Consumer>,
                fieldName: 'participants',
                minWidth: 150,
                maxWidth: 200,
                isResizable: true,
                data: 'string',
                onColumnClick: this._onColumnClick,
                onRender: (item: IDocument) => {
                    return <span>{item.userLogin}</span>;
                },
                isPadded: true
            },
            {
                key: 'column5',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "active")}</>)}</MyContext.Consumer>,
                fieldName: 'conversationId',
                minWidth: 150,
                maxWidth: 200,
                isRowHeader: true,
                isResizable: true,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                onColumnClick: this._onColumnClick,
                data: 'string',
                isPadded: true,
                onRender: (item: IDocument) => {
                    return <span>{item.conversationId}</span>;
                }
            },
            {
                key: 'column6',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "content")}</>)}</MyContext.Consumer>,
                fieldName: 'topic',
                minWidth: 120,
                maxWidth: 200,
                isRowHeader: true,
                isResizable: true,
                sortAscendingAriaLabel: 'Sorted A to Z',
                sortDescendingAriaLabel: 'Sorted Z to A',
                onColumnClick: this._onColumnClick,
                data: 'string',
                isPadded: true,
                onRender: (item: IDocument) => {
                    return <span>{item.topic}</span>;
                }
            },
            ];

        if (this.props.data.valueType === "size") {
                columns = [
                    {
                        key: 'column1',
                        name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "type")}</>)}</MyContext.Consumer>,
                        fieldName: 'storageType',
                        minWidth: 100,
                        maxWidth: 120,
                        isResizable: true,
                        data: 'string',
                        onColumnClick: this._onColumnClick,
                        onRender: (item: IDocument) => {
                            return <span>{item.storageType || 'User'}</span>;
                        },
                        isPadded: true
                    },
                    {
                        key: 'column2',
                        name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "identifier")}</>)}</MyContext.Consumer>,
                        fieldName: 'identifier',
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                        data: 'string',
                        onColumnClick: this._onColumnClick,
                        onRender: (item: IDocument) => {
                            return <span>{item.identifier}</span>;
                        },
                        isPadded: true
                    },
                    {
                        key: 'column3',
                        name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "name")}</>)}</MyContext.Consumer>,
                        fieldName: 'displayName',
                        minWidth: 200,
                        maxWidth: 300,
                        isResizable: true,
                        data: 'string',
                        onColumnClick: this._onColumnClick,
                        onRender: (item: IDocument) => {
                            return <span>{item.displayName}</span>;
                        },
                        isPadded: true
                    },
                    {
                        key: 'column7',
                        name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "size")}</>)}</MyContext.Consumer>,
                        fieldName: 'totalStorageBytes',
                        minWidth: 120,
                        maxWidth: 150,
                        isResizable: true,
                        data: 'number',
                        onColumnClick: this._onColumnClick,
                        isPadded: true,
                        onRender: (item: IDocument) => {
                            return <span>{item.totalStorageBytes ? (item.totalStorageBytes / (1024 * 1024 * 1024)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0.00'} GB</span>;
                        }
                    },
                    {
                        key: 'column8',
                        name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("conversationsPage", "lastUpdated")}</>)}</MyContext.Consumer>,
                        fieldName: 'storageLastUpdated',
                        minWidth: 150,
                        maxWidth: 180,
                        isResizable: true,
                        data: 'date',
                        onColumnClick: this._onColumnClick,
                        isPadded: true,
                        onRender: (item: IDocument) => {
                            return <span>{item.storageLastUpdated ? new Date(item.storageLastUpdated).toLocaleString() : '-'}</span>;
                        }
                    }
                ];
        }


        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });

        this.state = {
            items: this._allItems,
            groupedItems: this._allGroupedItems,
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: false,
            isCompactMode: false,
            isDialogOpen: false,
            total: this.total,
            totalSize: this.totalSize,
            totalTranscript: this.totalTranscript
        };

    }

    _onItemInvoked = (item) => {
        this.detailContainerRef.current.showPanelItem(item.conversationId, item.data)
    }

    _onExport = (ev) => {
        var itemList = [];
        var mainSheet = config.sheet.data;
        
        // For storage reports, use different headers
        if (this.props.data.valueType === "size") {
            itemList.push([
                { value: "Type", type: 'string' },
                { value: "ID", type: 'string' },
                { value: "Name", type: 'string' },
                { value: "Size (GB)", type: 'string' },
                { value: "Last Updated", type: 'string' }
            ]);
        } else {
            //add header to table
            itemList.push(mainSheet[0].slice());
        }
        
        const exportData = this.props.isGrouped ? this.state.groupedItems.flatMap(folder =>
            folder.reportEntries.map(item => ({
                ...item,
                folderName: folder.groupName
            }))) : this.state.items;
        
        if (this.props.data.valueType === "size") {
            // Export user/import/integration storage summary
            exportData.forEach((anItem) => {
                itemList.push([
                    { value: anItem.storageType || 'User', type: 'string' },
                    { value: anItem.identifier, type: 'string' },
                    { value: anItem.displayName, type: 'string' },
                    { value: anItem.totalStorageBytes ? (anItem.totalStorageBytes / (1024 * 1024 * 1024)).toFixed(2) : '0.00', type: 'number' },
                    { value: anItem.storageLastUpdated ? new Date(anItem.storageLastUpdated).toLocaleString() : '-', type:'string' }
                ]);
            });
        } else {
            // Export conversation details
            exportData.forEach((anItem) => {
                itemList.push(
                    [
                        {
                            value: anItem.date,
                            type: 'string'
                        }, {
                            value: anItem.starttime,
                            type: 'string'
                        }, {
                            value: anItem.userId,
                            type: 'string'
                        }, {
                            value: anItem.userLogin,
                            type: 'string'
                        }, {
                            value: anItem.conversationId,
                            type: 'string'
                        }, {
                            value: anItem.topic,
                            type: 'string'
                        }, {
                            value: anItem.size ? anItem.size.toFixed(2) : '0.00',
                            type: 'number'
                        }
                    ])
            });
        }
        config.sheet.data = itemList;
        zipcelx(config)
        config.sheet.data = mainSheet
        this.setState({ isDialogOpen: true });
    }


    _dialogClose = () => this.setState({ isDialogOpen: false })

    render() {
        const { columns, items, isModalSelection } = this.state;

        return (
            <MyContext.Consumer>
                {(context) => (<Fabric>
                    <DetailViewOverlay authorization={this.props.authorization} client={this.props.apol} ref={this.detailContainerRef} loading={true} userRules={this.props.userRules} theme={this.props.theme} />
                    <Dialog
                        isOpen={this.state.isDialogOpen}
                        type={DialogType.close}
                        onDismiss={this._dialogClose.bind(this)}
                        title='Excel export'
                        subText='Excel file created and downloaded to your favourite directory'
                        isBlocking={false}
                        closeButtonAriaLabel='Close'
                    />
                    <header className="report-panel-header ms-Grid-row" style={{ boxShadow: Depths.depth8 }}>
                        {/* == Recording Header ========================================= */}

                        <Stack horizontal>

                            <Text style={{ padding: "5px" }} >{this.translateDefaultTitles(this.props.data.title, context)}{this.props.data.overflow && ": Data Overflow"}</Text>
                            <Text style={{ padding: "5px" }} >{context.getTranslation("dashboard", this.props.data.kpi)} {context.getTranslation("dashboard", "user" + this.props.data.valueType?.replace(/^./, c => c.toUpperCase()))}</Text>
                            <Text style={{ padding: "5px" }} >{this.props.data.kpi === "Export" ? this.state.total + ", " + this.state.totalSize.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " GB, " + this.state.totalTranscript : ""}</Text>

                            <Stack.Item grow={2} ><div /></Stack.Item>

                            <SearchBox
                                placeholder="Search"
                                onChange={(event, newValue) => {
                                    if (event != null) event.persist();
                                    if (this.props.isGrouped) {
                                        this.setState({
                                            groupedItems: newValue ? this._allGroupedItems.map(folder => ({
                                                ...folder, reportEntries: folder.reportEntries.filter(i => (
                                                    (i.topic && i.topic.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                    (i.userId && i.userId.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                    (i.conversationId && i.conversationId.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                    (i.userLogin && i.userLogin.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                    (i.identifier && i.identifier.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                    (i.displayName && i.displayName.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                    (i.storageType && i.storageType.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                                ))
                                            })) : this._allGroupedItems
                                        })
                                    }
                                    else {
                                        this.setState({
                                            items: newValue ? this._allItems.filter(i => (
                                                (i.topic && i.topic.toLowerCase().indexOf(newValue.toLowerCase()) > -1) || 
                                                (i.transcription && i.transcription.toLowerCase().indexOf(newValue.toLowerCase()) > -1) || 
                                                (i.notes && i.notes.toLowerCase().indexOf(newValue.toLowerCase()) > -1) || 
                                                (i.userId && i.userId.toLowerCase().indexOf(newValue.toLowerCase()) > -1) || 
                                                (i.conversationId && i.conversationId.toLowerCase().indexOf(newValue.toLowerCase()) > -1) || 
                                                (i.userLogin && i.userLogin.toLowerCase().indexOf(newValue.toLowerCase()) > -1) || 
                                                (i.participants && i.participants.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                (i.identifier && i.identifier.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                (i.displayName && i.displayName.toLowerCase().indexOf(newValue.toLowerCase()) > -1) ||
                                                (i.storageType && i.storageType.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
                                            )) : this._allItems
                                        });
                                    }
                                }}
                            />
                            <CommandBarButton
                                iconProps={{ iconName: 'Download' }}
                                text="Export Report"
                                style={{ padding: "7px", cursor: "pointer", fontSize: FontSizes.Icon }}
                                onClick={this._onExport}
                                disabled = {!(this.props.isOwner || this.props.isManager || this.props.hasEntryListDownload)}
                            />
                        </Stack>
                    </header>
                    <div className="report-details-wrapper">

                        {/* == Player and meta data. ===================================== */}

                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <div className="ms-Grid-row">



                                </div>
                                {this.props.isGrouped && (

                                    <RIAccordion theme={this.props.theme}
                                        data={this.state.groupedItems.sort((a, b) => b.reportEntries.length - a.reportEntries.length).map((folder, i) => {
                                            return ({
                                                header: <div>{folder.groupName} ({folder.reportEntries.length})</div>,
                                                content:
                                                    <MarqueeSelection selection={this._selection}>
                                        <DetailsList
                                            items={folder.reportEntries}
                                            columns={columns}
                                            selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                                            setKey="set"
                                            layoutMode={DetailsListLayoutMode.justified}
                                            isHeaderVisible={true}
                                            selection={this._selection}
                                            selectionPreservedOnEmptyClick={true}
                                            onActiveItemChanged={this.props.data.valueType === "size" ? undefined : this._onItemInvoked}
                                            enterModalSelectionOnTouch={true}
                                            ariaLabelForSelectionColumn="Toggle selection"
                                            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                        />
                                                    </MarqueeSelection>

                                            })
                                        })}>
                                    </RIAccordion>
                                )}
                                {!this.props.isGrouped && (
                                    <MarqueeSelection selection={this._selection}>
                                        <DetailsList
                                            items={items}
                                            columns={columns}
                                            selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                                            setKey="set"
                                            layoutMode={DetailsListLayoutMode.justified}
                                            isHeaderVisible={true}
                                            selection={this._selection}
                                            selectionPreservedOnEmptyClick={true}
                                            onActiveItemChanged={this.props.data.valueType === "size" ? undefined : this._onItemInvoked}
                                            enterModalSelectionOnTouch={true}
                                            ariaLabelForSelectionColumn="Toggle selection"
                                            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                        />
                                    </MarqueeSelection>

                                )}
                            </div> {/* end of main contenten */}
                        </div>
                    </div>
                </Fabric>)
                }
            </MyContext.Consumer>);

    }
    componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }

    //Needs to be removed
    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {

        this.setState({
            items: text ? this._allItems.filter(i => i.topic.toLowerCase().indexOf(text) > -1) : this._allItems
        });
    };
    //Needs to be removed

    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return 'No items selected';
            case 1:
                return '1 item selected: ' + (this._selection.getSelection()[0]).name;
            default:
                return `${selectionCount} items selected`;
        }
    }

    _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { columns, items } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        const newItems = _copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
        this.setState({
            columns: newColumns,
            items: newItems
        });
    };

    //Needs to be removed
    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        this.setState({
            items: text ? this._allItems.filter(i => i.topic.toLowerCase().indexOf(text) > -1) : this._allItems
        });
    };
    //Needs to be removed

    _generateDocuments = (DataArr) => {
        const items = [];
        if (DataArr !== undefined) {
            this.totalSize = 0;
            this.totalTranscript = 0;
            this.total = 0;
            for (let i = 0; i < DataArr.length; i++) {
                let participants = "";
                if (DataArr[i].linkedUser != null) {
                    participants += DataArr[i].linkedUser.length;
                    DataArr[i].linkedUser.map((item, i) => {
                        participants += " , " + item.name;
                    });
                }
                // Backend sends userId and userLogin with appropriate values based on storage type
                let storageType = 'User';
                if (DataArr[i].scenarioId) {
                    storageType = 'Import';
                } else if (DataArr[i].integrationName || DataArr[i].botAppId) {
                    storageType = 'Integration';
                }
                
                let identifier = DataArr[i].userId;
                let displayName = DataArr[i].userLogin;

                items.push({
                    id: DataArr[i].id,
                    conversationType: DataArr[i].recordingType,
                    topic: DataArr[i].topic != null ? DataArr[i].topic : "",
                    conversationDirection: DataArr[i].recordingType,
                    conversationId: DataArr[i].conversationId,
                    date: DataArr[i].day,
                    dateValue: DataArr[i].callStartMs,
                    starttime: DataArr[i].timein,
                    duration: DataArr[i].duration,
                    userId: DataArr[i].userId,
                    userLogin: DataArr[i].userLogin,
                    botAppId: DataArr[i].botAppId,
                    participants: participants,
                    notes: DataArr[i].notes != null ? DataArr[i].notes : "",
                    transcription: DataArr[i].speech2Text != null ? DataArr[i].speech2Text : 0,
                    size: DataArr[i].size,
                    exportComment: DataArr[i].exportComment,
                    data: DataArr[i],
                    errorMessage: DataArr[i].errorMessage,
                    errorCode: DataArr[i].errorCode,
                    scenarioId: DataArr[i].scenarioId,
                    storageLastUpdated: DataArr[i].storageLastUpdated,
                    totalStorageBytes: DataArr[i].totalStorageBytes,
                    integrationName: DataArr[i].integrationName,
                    storageType: storageType,
                    identifier: identifier,
                    displayName: displayName

                });
                this.total++;
                this.totalSize += DataArr[i].totalStorageBytes ? DataArr[i].totalStorageBytes / (1024 * 1024 * 1024) : (DataArr[i].size || 0);
                this.totalTranscript += parseInt(DataArr[i].speech2Text);
            }
        }
        return items;
    }

    generateFriendlyErrorCode = (errCode) => {
        switch (errCode) {
            case "UNKNOWN":
                return "Unknown";
            case "FILE_NOT_FOUND":
                return "File not found";
            case "COULD_NOT_IMPORT_CONV":
                return "Could not import conversation";
            case "EXCEPTION":
                return "Exception"
            case "COULD_NOT_IMPORT_METADATA":
                return "Could not import metadata";
            case "CONV_EXISTS_ALREADY":
                return "Conversation already exists";
            case "USER_NOT_FOUND":
                return "User not found";
            case "INVALID_FORMAT":
                return "Invalid format";
            case "MEDIA_PROCESSING":
                return "Media processing";
            case "DATABASE_ERROR":
                return "Database error";
            case "FILE_TRANSFER":
                return "File transfer";
            case "PENDING":
                return "Pending";
            default: return ""
        }
    }

    //translate only default titles, if it's not a match will show original title
    translateDefaultTitles = (title, context) => {
        const phrases = {
            "Conversations Recorded per Month during the Year": "conversationsRecordedPerMonthDuringYear",
            "Conversations Recorded per Day during Last Month": "conversationsRecordedPerDayDuringLastMonth",
            "Conversations Recorded per Hour Yesterday": "conversationsRecordedPerHourYesterday",
            "Conversations Recorded per Day during Last Week": "conversationsRecordedPerDayDuringLastWeek",
            "Detailed Report on Call Recording Problems by Category": "detailedReportOnCallRecordingProblemsByCategory",
            "Conversations Recorded vs. the Calls with Problems": "conversationsRecordedVsCallsWithProblems",
            "System Activity: Users being Recorded": "systemActivityUsersBeingRecorded",
            "System Availability: Bot Clusters & Backend Services (0=working, 1=problems)": "systemAvailabilityBotClustersBackendServices",
            "System Activity: Total Duration of Recordings": "systemActivityTotalDurationOfRecordings",
            "System Activity: Number of Deleted Conversations": "systemActivityNumberOfDeletedConversations",
            "Total Duration of Recordings": "totalDurationOfRecordings",
            "Recorded Conversations Breakdown by Days & Type": "recordedConversationsBreakdownByDaysType",
            "Call Conversations Today": "callConversationsToday",
            "Inbound Call Conversations": "inboundCallConversations",
            "Outbound Call Conversations": "outboundCallConversations"
        };

        return (phrases[title] ? context.getTranslation("dashboard", phrases[title]) : title);
    }
}



function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}




